/**************************************************
 * Nombre:       Formulario_Habitaciones_Caracteristica
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoImagenCropLista from "../../../Modulo_formularios/Componentes/IngresoImagenCropLista";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";

const Formulario_Habitaciones_Caracteristica = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop dato={'img'} {...props} ancho={1} alto={1}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto dato={'nombre'} nombre={'Caracteristica'}  {...props}  />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Habitaciones_Caracteristica